export class PontuacaoBeneficio {
    public codigo: number;
    public beneficio: number;
    public negado: boolean;
    public justificativaNegacao: string;
    public codigoPontuacao: number;

    // transient
    public solicitado:boolean;
    public descricaoOpcao:string;
    public nomeUnicoOpcao:string;

}
